import { render, staticRenderFns } from "./fake-form-item.vue?vue&type=template&id=1bd925b3"
import script from "./fake-form-item.vue?vue&type=script&lang=js"
export * from "./fake-form-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports